import { Component } from '@angular/core';

@Component({
  selector: 'wchfs-nav-sublist-item',
  templateUrl: './nav-sublist-item.component.html',
  styleUrls: ['./nav-sublist-item.component.scss'],
})
export class NavSublistItemComponent {}
